import React, { Component } from "react";
import utils from "../../libs/utils";

import config from "data/config";

export default class Image extends Component {
  constructor(props) {
    super(props);

    setTimeout(() => this.setState({ isClient: utils.isClient() }), 50);

    this.state = {};
  }

  render() {
    let src =
      this.props.preloadSrc ||
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8+f9vPQAJZAN2rlRQVAAAAABJRU5ErkJggg==";
    let dataPiio = this.props.src;
    const srcIsString =
      typeof this.props.src === "string" || this.props.src instanceof String;

    if (
      srcIsString &&
      (!dataPiio || dataPiio.startsWith("data:") || config.piio.development)
    ) {
      if (this.props.highPriority || this.state.isClient) {
        // this is done to void inlining in a case where we really do not want inlining - so basically only the client render will generate the code
        // for this...
        src = dataPiio;
      }
      dataPiio = "";
    }

    const fieldProps = { ...this.props };
    delete fieldProps.highPriority;
    delete fieldProps.preloadSrc;

    // For some reason SVGs don't like being loaded async
    if (!srcIsString || this.props.src.indexOf("svg") != -1) {
      delete fieldProps["data-src"];
      if (this.props.src.default) {
        return <img {...fieldProps} src={this.props.src.default} />;
      } else {
        return <img {...fieldProps} src={this.props.src} />;
      }
    }

    fieldProps["data-src"] = dataPiio;

    if (!dataPiio) {
      delete fieldProps["data-src"];
    }

    return <img {...fieldProps} src={src} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Image/index.js